import InputEntryExitType from "components/input-entry-exit-coupon";
import { useOfmFiltersState } from "../../ducks/filter/hooks/state";
import { useOfmFiltersActions } from "../../ducks/filter/hooks/actions";

export default function SelectEntryExit() {
  const { filters } = useOfmFiltersState();
  const { setInvoiceType } = useOfmFiltersActions();

  const value = (filters?.invoiceType as "E" | "S" | undefined) ?? undefined;

  return (
    <InputEntryExitType
      label="Entrada/Saída"
      value={value}
      placeholder="Selecionar (Entrada/Saída)"
      onChange={(v?: string) => setInvoiceType(v as any)}
    />
  );
}
